import { MainPadding } from "../../../styles/Main.styles";
import { useState } from "react";
import TableHeader from "../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import { useGetSubDealers } from "../api/supplier/resolver";

export default function Main() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawSubDealer, isLoading: loadingFetchSupplier } =
    useGetSubDealers({ keyword, page, perPage });
  const dataSubDealer = dataRawSubDealer?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama" },
    { title: "Telp" },
    { title: "Alamat" },
    { title: "Catatan" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "sub_dealer_name" },
    { key: "sub_dealer_phone_number" },
    { key: "sub_dealer_address" },
    { key: "description" },
  ];

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search sub dealer"
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/dealer/creation")}
      />
      <TableFC
        loading={loadingFetchSupplier}
        data={dataSubDealer}
        body={body}
        showIndex
        totalRows={dataRawSubDealer?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/dealer/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
